import React, { useState, useEffect, useContext } from "react";
import "../../../ui-styles/sliders/RightFullSlider.css"
import "../../../ui-styles/list/profileVertical.css";
import { dateFormat, getAge } from "../../../lib/functions";
import { LangCtx } from "../../../lib/context";
import NoData from "../../../lib/ui/nodata/NoData";
import UploadFilesListItem from "../../common/fileUploads/components/slidelistItem";
import { getPatientDrugAllegiesById, getPatientMedicalFilesById } from "../../../actions/appointment";
import Loader from "../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';


const PatientVisitSlide = (props) => {
    const { l } = useContext(LangCtx);
    const [loading, setLoading] = useState(false);
    //  const [files, setFile] = useState(file_data);
    // const [patient, setPatient] = useState({});
    const { patientData } = props.data;
    const [uploadData,setUploadData]=useState(props?.data?.uploads && props.data.uploads.length>0 ? props.data.uploads:[]);

    // const files = props.data.uploads ? props.data.uploads : []
    const [drugs, setDrugs] = useState([]);

    const loadDrugs = () => {
        getPatientDrugAllegiesById(patientData.userId).then(res => {
            setLoading(false)
            if (res.status && res.data) {
                setDrugs(res.data)
            }
        }).catch(err => {
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
            console.log("err ==== ", err);
        })
    }

    const patientUploadData=()=>{
        getPatientMedicalFilesById(patientData.userId).then(res => {
            // setLoading(false);
            if (res.data && res.status) {
                setUploadData([...uploadData, ...res.data])
            }
        }).catch(err => {
            // setLoading(false);
            console.log("err in loading doctors files ==== ", err);
        })
    }

    useEffect(() => {
        if (patientData && patientData.userId){
            setLoading(true)
            patientUploadData()
            loadDrugs();
        }
    }, [patientData]);

    return (
        <div className={props.patientSlide ? "rightFullSlider fullSlide rightSliderIn" : "rightFullSlider fullSlide"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.pat_details}</span>
                    </div>
                    <div className="hdrActionGroup" onClick={props.close}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            {loading ? <Loader /> :

                <div className="rightSliderBdy">
                    <div className="profleAvtrRow">
                        <div className="profleAvtrCircle">
                            {patientData.profileImage ?
                                <img src={patientData.profileImage.url} alt="avatar" />
                                :
                                <img src="/images/icons/patient-default.png" alt="avatar" />
                            }
                        </div>
                        <div className="profileMinDtls">
                            <span className="profileLtxt">{patientData.title ? patientData.title : ''}{patientData.firstName ? `${patientData.firstName} ` : ''}{patientData.lastName ? `${patientData.lastName}` : ''}</span>
                            <span className="profileStxt capitalizeTxt">{patientData.gender ? patientData.gender : ''} {patientData.dob ? `- ${getAge(new Date(patientData.dob))}` : ''}</span>
                        </div>
                    </div>
                    <div className="inColBlock">
                        <span className="subHdngSm">{l.reas_for_call}</span>
                        <p className="summaryTxt">{props.data.reason ? l[props.data.reason] : ''}</p>
                        <span className="subHdngSm">{l.pat_visit_summary}</span>
                        <p className="summaryTxt">{props.data.description ? decodeURIComponent(props.data.description) : ''}</p>
                    </div>

                    <div className="inColBlock">
                        <span className="subHdngSm">{l.attachments}:</span>
                        <ul className="colListGroup">
                            {uploadData?.length > 0 ? uploadData?.map((item, i) => <UploadFilesListItem file={item} key={`${item.key}_${i}`} access={false} />) :
                                < NoData Heading={l.no_files} src="/images/file-icons/blank-file.png" label='' />
                             }
                        </ul>
                    </div>

                    <div className="inColBlock">
                        <span className="subHdngSm">{l.drug_All}:</span>
                        <ul className="colListGroup">
                            {drugs.map(drugItem =>
                                <>
                                    <li className="colListItem">
                                        <span className="subHdngSm">{l.drug_name}:</span>
                                        <span className="itemTxt">{decodeURIComponent(drugItem.name)}</span>
                                    </li>
                                </>
                            )
                            }
                        </ul>
                    </div>
                    <div className="inColBlock">
                        <span className="subHdngSm">{l.contact_details}:</span>
                        <ul className="colListGroup">
                            <li className="colListItem">
                                <span className="subHdngSm">{l.pat_phone_no}</span>
                                <span className="itemTxt">{patientData.phone ? patientData.phone : ''}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.alt_phone_no}</span>
                                <span className="itemTxt">{patientData.alterNatePhone ? patientData.alterNatePhone : ''}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.email_address}:</span>
                                <span className="itemTxt">{patientData.email ? patientData.email : ''}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.address}:</span>
                                <span className="itemTxt">{patientData.address ? patientData.address : ''}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.label_dob}</span>
                                <span className="itemTxt">{patientData.dob ? dateFormat(patientData.dob) : ''}</span>
                            </li>
                        </ul>
                    </div>
                </div>}
        </div>
    )
}

export default PatientVisitSlide;